// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "mobileScreen__header-1gC6s";
var _3 = "rules-1-Rl-";
var _4 = "wrapper-2Ucjy";
var _5 = "insurances-116mM";
var _6 = "controls-3PmZH";
var _7 = "documents-103pV";
var _8 = "dialog__button_done-UWTWK";
var _9 = "dialog__button_clear-2Dd0k";
export { _1 as "__esModule", _2 as "mobileScreen__header", _3 as "rules", _4 as "wrapper", _5 as "insurances", _6 as "controls", _7 as "documents", _8 as "dialog__button_done", _9 as "dialog__button_clear" }
export default { "__esModule": _1, "mobileScreen__header": _2, "rules": _3, "wrapper": _4, "insurances": _5, "controls": _6, "documents": _7, "dialog__button_done": _8, "dialog__button_clear": _9 }
